.linkContainer {
    display: flex;
}
